var _rect, _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSales = function SvgSales(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 110 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 80,
    rx: 8,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.143 60h-4.286C48.73 60 47 58.738 47 57.187V37.814C47 36.261 48.73 35 50.857 35h4.286C57.27 35 59 36.262 59 37.813v19.374C59 58.739 57.27 60 55.143 60Z",
    fill: "url(#sales_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.35 56h-4.14a3.73 3.73 0 0 1-3.727-3.727v-17.39a3.73 3.73 0 0 1 3.727-3.727h4.14a3.73 3.73 0 0 1 3.727 3.727v17.39A3.73 3.73 0 0 1 39.351 56Z",
    fill: "url(#sales_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.819 65h-4.14a3.73 3.73 0 0 1-3.727-3.727V28.906h-2.276c-1.063 0-2-.6-2.445-1.567a2.664 2.664 0 0 1 .426-2.903l8.858-9.885a1.656 1.656 0 0 1 2.467 0l8.858 9.885.024.027c.693.808.846 1.91.402 2.876a2.664 2.664 0 0 1-2.445 1.567h-2.275v32.367A3.73 3.73 0 0 1 70.819 65Z",
    fill: "url(#sales_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.842 38.047a1.5 1.5 0 0 1 1.653-.463l39.16 13.706 14.84-13.403 2.01 2.226-15.5 14a1.5 1.5 0 0 1-1.5.303L29.491 40.762l-6.334 7.692-2.316-1.907 7-8.5Z",
    fill: "#5298F4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sales_svg__a",
    x1: 53,
    y1: 29,
    x2: 53,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sales_svg__b",
    x1: 37,
    y1: 27.5,
    x2: 37.28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sales_svg__c",
    x1: 68.749,
    y1: -11.5,
    x2: 68.749,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E2E3"
  })))));
};

export default SvgSales;